// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// assets
import ThreeDots from "src/assets/icons/three-dots.svg";
import ThreeDotsDark from "src/assets/icons/three-dots-dark.svg";

const Button = ({ label, fill, handleClick, isLoading }) => {
  return (
    <div className={styles.button}>
      <button className={`${fill ? styles.fill : ""}`} onClick={handleClick}>
        {!isLoading ? (
          label
        ) : (
          <>
            <img className={styles.md} src={ThreeDots} alt="loading" />
            <img className={styles.sm} src={ThreeDotsDark} alt="loading" />
          </>
        )}
      </button>
    </div>
  );
};

export default Button;
